<template>
  <div class="app-link">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${i}`"
        class="input-group">

        <el-select
          v-if="options.relations"
          v-model="valueLocal[i].relation"
          :key="`app-link-opt-${i}`"
          :class="{ 'child-has-error': error[i].relation }"
          :clearable="typeof options.clearable !== 'undefined' ? options.clearable : true"
          @focus="clearError('relation', i)"
          @change="byRelationLinkFormat($event, i)"
          v-bind="widgetOptions">
          <el-option
            v-for="(value, relation, i) in options.relations"
            class="select-option"
            :key="`app-link-opt-option-${i}`"
            :label="`${value.Title} (${value.Description})`"
            :value="relation"/>
        </el-select>
        <div v-if="error[i].relation" class="ait_message ait_message--error">
          {{ error[i].relation }}
        </div>
        <el-switch
          v-show="isSelectableFormat[i] && valueLocal[i].relation"
          v-model="valueLocal[i].format"
          class="switch-type"
          active-color="#fff"
          inactive-color="#fff"
          :active-value="'object'"
          :inactive-value="'resource'"
          active-text="Объект"
          inactive-text="Ссылка"/>

        <div class="input-subtitle">{{ getFormatName(i) }}</div>
        <el-input
          :class="{ 'child-has-error': error[i].link || error[i].object }"
          @focus="clearError('link', i), clearError('object', i)"
          v-model="valueLocal[i].link"/>
        <div class="format-example">
          {{ getFromatExample(i) }}
        </div>
        <div v-if="error[i].link" class="ait_message ait_message--error">
          {{ error[i].link }}
        </div>
        <div v-if="error[i].object" class="ait_message ait_message--error">
          {{ error[i].object }}
        </div>
        <div class="input-subtitle">Описание</div>
        <el-input v-model="valueLocal[i].title"/>
        <div v-if="error[i].required" class="ait_message ait_message--error">
          {{ error[i].required }}
        </div>
      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: {
        relation: '',
        format: '',
        link: '',
        title: '',
      },
      isSelectableFormat: [],
      errorBase: { required: '', relation: '', link: '' },
    };
  },

  created() {
    this.error.push(this.errorBase);
    this.widgetOptions.placeholder = 'Выберите значение...';
    // Add error messages
    this.validateMessages = Object.assign(
      this.validateMessages, {
        relation: 'Выберите тип ссылки',
        link: 'Неправильный формат ссылки',
        object: 'Неправильный формат идентификатора объекта',
      },
    );
  },

  methods: {

    byRelationLinkFormat(event, i) {
      if (!event) {
        this.isSelectableFormat[i] = false;
        this.valueLocal[i].format = 'resource';
        this.valueLocal[i].link = '';
        this.valueLocal[i].title = '';
      } else {
        const relation = this.options.relations[event];
        if (relation.Formats.length === 2) this.isSelectableFormat[i] = true;
        else {
          this.isSelectableFormat[i] = false;
          this.valueLocal[i].format = relation.Formats[0];
        }
      }
    },

    getFormatName(i) {
      if (this.valueLocal[i].format === 'resource') return 'Ссылка';
      return 'Объект';
    },

    getFromatExample(i) {
      if (this.valueLocal[i].format === 'resource') return 'Укажите ссылку на внешний ресурс, например, https://www.elibrary.ru/project_books.asp';
      return 'Укажите IPC-код задепонированного объекта, например, IPC-RU.IPU.GN.2018-0OMXF0T6.3';
    },

    setValue(value) {
      this.valueLocal = [];
      value.forEach((v, i) => {
        this.error[i] = this.errorBase;
        this.valueLocal.push({
          relation: v.Relation,
          format: v.Format,
          link: v.Link,
          title: v.Title,
        });
        if (v.Relation) this.byRelationLinkFormat(v.Relation, i);
      });
      this.$forceUpdate();
    },

    getValue() {
      const vl = this.valueLocal;
      const r = [];
      vl.forEach((v) => {
        if (v.link) {
          let inValue = v.link.replace(/^\s+/g, '');
          inValue = inValue.replace(/\s+$/g, '');
          r.push({
            Relation: v.relation,
            Format: v.format,
            Link: inValue,
            Title: v.title,
          });
        }
      });
      if (this.options && this.options.multiple) {
        return r;
      }
      return r.length ? r[0] : null;
    },

    getError() {
      this.valueLocal.forEach((value, i) => {
        this.error[i] = { required: '', relation: '', link: '' };
        let inValue = '';
        if (value.link) {
          inValue = value.link.replace(/^\s+/g, '');
          inValue = inValue.replace(/\s+$/g, '');
        }
        if (this.options.required && !inValue) {
          this.error[i].required = this.validateMessages.required;
        }
        if (inValue && !value.relation) {
          this.error[i].relation = this.validateMessages.relation;
        }
        if (inValue && value.format === 'resource') {
          const regex = /^((http|https):\/\/){1}(www([0-9]+|\b)\.){1}([A-ZА-Яа-я0-9-_#!:.?+=&%@!/])+$/i;
          const matches = regex.exec(inValue);
          if (!matches) this.error[i].link = this.validateMessages.link;
        } else if (inValue && value.format === 'object') {
          const regex = /^IPC[A-Z0-9-.]+$/;
          const matches = regex.exec(inValue);
          if (!matches) this.error[i].link = this.validateMessages.object;
        }
      });
      this.updateValue();
      return this.error;
    },

    clearError(elName, i) {
      if (this.error[i][elName]) {
        this.error[i].required = '';
        this.error[i][elName] = '';
        this.$forceUpdate();
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.app-link {
  .input-group {
    border-bottom: 1px dotted rgba(255, 255, 255, .3);
    padding-bottom: 32px;
    &:last-of-type {
      border-bottom: none!important;
      padding-bottom: 20px;
    }
  }
  .el-switch,
  .input-subtitle {
    margin-top: 20px;
  }
  .format-example {
    margin-top: 5px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppLink.vue